import { TextField, TextFieldProps } from "@suraasa/placebo-ui"
import { useQueryClient } from "@tanstack/react-query"
import api from "api"
import { APIError } from "api/utils"
import { useForm } from "react-hook-form"
import { useParams } from "react-router-dom"
import { toast } from "react-toastify"
import { mapErrors } from "utils/helpers"

type Props = {
  saveKey: string
  value: string | number
  userPrimaryKey: string | number
} & TextFieldProps

const AutoSaveDateField = (props: Props) => {
  const { userId } = useParams()
  const queryClient = useQueryClient()

  const { saveKey, value, userPrimaryKey, ...textFieldProps } = props

  const {
    register,
    formState: { errors },
    getValues,
    setError,
  } = useForm({
    defaultValues: {
      [saveKey]: value,
    },
  })

  const save = async () => {
    const values = getValues()
    const value = values[saveKey]

    const data = {
      [saveKey]: value,
    }

    try {
      await api.lead.saveData({
        data,
        params: {
          userPrimaryKey,
        },
      })

      // @ts-expect-error this is safe to do
      queryClient.setQueryData<LeadProfile>(["profile", userId], oldData => ({
        ...(oldData ?? {}),
        ...data,
      }))
    } catch (error) {
      if (error instanceof APIError) {
        const err = error.errors

        if (err.message) {
          toast.error(err.message)
          return
        }
        if (err.fieldErrors) {
          mapErrors(setError, err, [[saveKey]])
          return
        }
      }
    }
  }
  return (
    <TextField
      {...register(saveKey, {
        onBlur: save,
      })}
      errors={errors[saveKey]?.message}
      type="date"
      {...textFieldProps}
    />
  )
}

export default AutoSaveDateField
